import React from 'react';

import { CreativeV5Type } from '../../../../apis/graphql';
import Loader from '../../../Loader';
import type { CreativeBuilderProps } from '../CreativeBuilder';
import DxcCreativeBuilder from '../DxcCreativeBuilder';

export const PLACEHOLDER_DXC_TEXT = 'Outstream DXC creatives are not supported yet!';

export const wrapWithDxcCreativeBuilder = (
  component: (props: CreativeBuilderProps) => React.JSX.Element
): ((props: CreativeBuilderProps) => React.JSX.Element) => {
  return (props: CreativeBuilderProps): React.JSX.Element => {
    if (props.loadingCreativeData) return <Loader />;

    if (
      props?.creativeData?.getCreativeByIDV5.type === CreativeV5Type.InstreamDxc ||
      props?.creativeData?.getCreativeByIDV5.type === CreativeV5Type.OutstreamDxc
    ) {
      return <DxcCreativeBuilder {...props} />;
    }

    return component(props);
  };
};
